module.exports = __webpack_public_path__ + "static/img/3.fc1ae5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/goods/legao/3.jpg
// module id = +lt6
// module chunks = 1